<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper"></div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div class="text-left content-preview" v-html="node.text"></div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      class="mb-4 w-full"
      :current-content="node.text"
      :editor-height="120"
      live-chat-message-preset
      title="Text"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <v-text-field
      v-model="node.link"
      class="mb-4 panzoom-ignore"
      :label="$t('shortcodes.live_chat_mp4.action_item_link')"
      persistent-placeholder
      placeholder="https://"></v-text-field>

    <VaColorPicker
      class="mb-4 panzoom-ignore"
      :title="'Background color'"
      :mode="'hex'"
      hide-alpha-slider
      v-model="node.backgroundColor"></VaColorPicker>

    <VaColorPicker
      class="mb-4 panzoom-ignore"
      :title="$t('shortcodes.live_chat_mp4.button_text_color')"
      :mode="'hex'"
      hide-alpha-slider
      v-model="node.textColor"></VaColorPicker>

    <v-checkbox
      v-if="$can('view', 'live chat ringba parameters')"
      class="mb-3"
      :label="'Ringba replace script'"
      v-model="node.hasRingbaScript"
      color="primary"
      hide-details="auto"
      @change="hasRingbaScriptChange">
    </v-checkbox>

    <v-checkbox
      v-if="$can('view', 'live chat ringba parameters')"
      class="mb-3"
      :label="'Update ringba tags'"
      v-model="node.updateRingbaTags"
      color="primary"
      hide-details="auto">
    </v-checkbox>

    <code-input
      v-if="node.hasRingbaScript"
      class="panzoom-ignore ringba-script-input mb-3"
      v-model="node.ringbaScript"
      :title="'Ringba script'"></code-input>
    <VaAudioFileInput
      :label="'Audio file'"
      :file-id="fileId"
      @update:file="updateAudioFile"
      :file-name="fileName"
      :file-url="fileUrl"></VaAudioFileInput>

    <div class="mt-4">
      <!---- ARRAY INPUT START -->
      <div>
        <va-array-input
          class="ringba-tags-input"
          v-slot="props"
          v-model="node.ringbaTags"
          :label="'Ringba tags'"
          :add-button-text="'Add tag'"
          :block-label="'Ringba tag'"
          column-layout-without-drag
          allow-empty>
          <div class="d-flex mt-3">
            <v-text-field
              class="panzoom-ignore flex-1 mr-1"
              :label="'Tag'"
              :placeholder="'Tag'"
              persistent-placeholder
              v-model="node.ringbaTags[props.index].tag"
              @input="tagChange(props.index, $event)" />

            <v-select
              :disabled="!node.ringbaTags[props.index].tag"
              :label="'Value'"
              v-model="node.ringbaTags[props.index].value"
              class="panzoom-ignore flex-1 ml-1"
              hide-details
              :items="RINGBA_TAG_VALUES"
              attach
              :menu-props="{
                offsetOverflow: true,
                offsetY: true,
              }">
            </v-select>
          </div>
        </va-array-input>
      </div>
      <!---- ARRAY INPUT END -->
    </div>
  </div>
</template>

<script>
  import CodeInput from "@/components/custom/CodeInput";
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import VaAudioFileInput from "@/components/custom/VaAudioFileInput";
  import { AUDIO_FILE, RINGBA_TAG_VALUES } from "./constant";

  /* eslint-disable */
  export default {
    name: "LiveChatMp4ActionItem",
    components: { CodeInput, VaColorPicker, VaAudioFileInput },
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        RINGBA_TAG_VALUES,
        showEditor: !this.node?.text,
      };
    },
    computed: {
      fileId() {
        return this.node?.audio?.fileID || "";
      },
      fileName() {
        return this.node?.audio?.fileName || "";
      },
      fileUrl() {
        return this.node?.audio?.fileURL || "";
      },
    },
    beforeMount() {
      if (typeof this.node?.ringbaTag?.value !== "undefined" && this.node?.ringbaTag?.value !== null) {
        const ringbaTags = [{ ...this.node.ringbaTag, id: 1 }];
        this.$set(this.node, "ringbaTags", ringbaTags);
        delete this.node.ringbaTag;
      } else {
        delete this.node.ringbaTag;
      }

      if (!this.node?.ringbaTags?.length) {
        this.$set(this.node, "ringbaTags", []);
      }
    },
    methods: {
      tagChange(index, value) {
        if (!value) {
          this.node.ringbaTags[index].value = null;
        }
      },
      hasRingbaScriptChange(val) {
        if (!val) {
          this.node.ringbaScript = "";
        }
      },
      updateMessageContent(content) {
        this.node.text = content;
        this.node.value = content;
      },
      updateAudioFile(fileData) {
        if (fileData) {
          this.$set(this.node, "audio", {});
          this.node.audio.fileID = fileData["@id"];
          this.node.audio.fileURL = fileData.contentUrl;
          this.node.audio.fileName = fileData.fileName;
        } else {
          this.node.audio = { ...AUDIO_FILE };
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .ringba-script-input {
    text-align: left;
  }

  .ringba-tags-input {
    &::v-deep {
      .btn-custom-add {
        margin-top: 25px;
      }
      .column-layout-without-drag {
        & > div {
          &:not(:first-child) {
            border-top: 1px dashed get-color("primary-65");
            margin-top: 20px;
            padding-top: 20px;
          }
          &:last-of-type {
            border-bottom: 1px dashed get-color("primary-65");
            padding-bottom: 20px;
          }
        }
      }
    }
  }
</style>
